import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ClassIcon(props: IconProps) {
    return <Icon {...props} iconKey={"class"}/>
}
